import { connect } from 'react-redux';
import { Link } from 'react-router-dom';

import AddressDisplay from 'common/components/address/AddressDisplay';
import {
  getDefaultAddress,
  getNonDefaultAddresses
} from 'redux/customerAddresses/reducers';

const AddressBook = (props) => {
  const { defaultAddress, nonDefaultAddresses } = props;
  if (!nonDefaultAddresses) {
    return null;
  }
  let addressCount = 0;
  if (defaultAddress) {
    addressCount += 1;
  }
  const totalAddresses = nonDefaultAddresses.length + addressCount;
  const maxRows = 2;
  const moreNumber = totalAddresses > maxRows ? totalAddresses - maxRows : null;
  const displayArray = nonDefaultAddresses.slice(0, maxRows - addressCount);
  return (
    <div className="c7-account-tile">
      <h3>Address Book</h3>

      {totalAddresses === 0 && (
        <>
          You have no saved addresses on file.
          <br />
          <br />
          <Link to="/profile/address-book/add" className="c7-button-small">
            Add first address
          </Link>
        </>
      )}

      {defaultAddress && (
        <div className="c7-account-tile__section">
          <AddressDisplay address={defaultAddress} boldName />
          <br />
          <em>(Default)</em>
          <Link
            to={`/profile/address-book/${defaultAddress.id}`}
            className="c7-button-alt-small"
          >
            Edit
          </Link>
        </div>
      )}

      {displayArray.map((address) => (
        <div key={address.id} className="c7-account-tile__section">
          <AddressDisplay address={address} boldName />
          <br />
          <Link
            to={`/profile/address-book/${address.id}`}
            className="c7-button-alt-small"
          >
            Edit
          </Link>
        </div>
      ))}
      <br />
      {renderMore(moreNumber)}
    </div>
  );
};

const mapStateToProps = (state) => ({
  defaultAddress: getDefaultAddress(state.customerAddress),
  nonDefaultAddresses: getNonDefaultAddresses(state.customerAddress)
});

export default connect(mapStateToProps)(AddressBook);

const renderMore = (moreNumber) => {
  if (!moreNumber) {
    return null;
  }
  return (
    <Link to="/profile/address-book" className="c7-button-small">
      View {moreNumber} more
    </Link>
  );
};
